/*@flow*/
import styled from '@emotion/styled';

export default (styled.div(
  `
  padding: 20px;
  display: grid;
  align-items: center;
  min-height: 12rem;
  border-bottom: solid 1px #ccc;
  scroll-snap-align: start;
  position: relative;
`,
  props => props.styles
): any);
